export enum SecondaryMenuItemsIds {
  goToPage = 5,
  myAccount = 6,
  helpSupport = 7,
  logOut = 8,
}
